import axios from 'axios'
import { IApiOptions } from 'shared/contracts/IApiOptions'
import {
  IChifamDetailsReq,
  IChifamDetailsRes,
  IChifamHoldingDetail,
  IChifamHoldingsSummaryReq,
  IHoldings,
  IChifamAccountsReq,
  IChifamAccountsRes
} from './types'

const fetchChifamDetailsService = (
  req: IChifamDetailsReq,
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdm/chifam/GetChifamDetails`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .post<IChifamDetailsRes>(url, req, {
      headers,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}

const fetchChifamHoldingsService = (
  req: IChifamHoldingsSummaryReq,
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdm/chifam/HoldingsDetail`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .get<IHoldings>(url, {
      headers,
      params: req,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}

const fetchChifamHoldingSummaryService = (
  req: IChifamHoldingsSummaryReq,
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdm/chifam/HoldingsSummary`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .get<IChifamHoldingDetail[]>(url, {
      headers,
      params: req,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}

const fetchAccountsService = (req: any, options: IApiOptions) => {
  const url = `${options.apiRoot}/datahub/search/accounts`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .post<any>(url, req, {
      headers,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}

const insertUpdateReallocationService = (
  req: IHoldings,
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdm/chifam/InsertUpdateReallocation`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .post<any>(url, req, {
      headers,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}

const generateDocumentService = (
  req: { documentType: string; holdingDate: string },
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdm/DocumentGeneration/GenerateDocument`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .get(url, {
      headers,
      params: req,
      responseType: 'blob',
      cancelToken: options.cancelToken
    })
    .then(async (res) => {
      // Check if response is JSON error (not a PDF)
      if (res.data.type === 'application/json') {
        const text = await res.data.text()
        const errorResponse = JSON.parse(text)
        // Throw error with errorCode and message
        const error: any = new Error(
          errorResponse.message || 'Failed to generate document'
        )
        error.errorCode = errorResponse.errorCode
        error.message = errorResponse.message
        throw error
      }
      return res.data
    })
}

const fetchChifamAccountsService = (
  req: IChifamAccountsReq,
  options: IApiOptions
) => {
  const url = `${options.apiRoot}/cdm/chifam/GetChifamAccounts`
  const headers = {
    Authorization: `Bearer ${options.accessToken}`
  }
  return axios
    .get<IChifamAccountsRes>(url, {
      headers,
      params: req,
      cancelToken: options.cancelToken
    })
    .then((res) => res.data)
}

export {
  fetchChifamDetailsService,
  fetchChifamHoldingsService,
  fetchChifamHoldingSummaryService,
  fetchAccountsService,
  insertUpdateReallocationService,
  generateDocumentService,
  fetchChifamAccountsService
}
